<div class="project-item">
  <img
    class="item-icon"
    [src]="project.icon"
    (error)="$event.currentTarget.src = 'assets/project-icon/no_project.png'"
  />
  <span class="item-name">{{ project.name }}</span>
</div>
